module.exports = __webpack_public_path__ + "static/img/IS.27037f5f.svg";